import { createContext } from 'react';
import { AdjustmentModalContextProps } from './AdjustmentModal.types';

const AdjustmentModalContext =
  // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  createContext<AdjustmentModalContextProps>(undefined);

export default AdjustmentModalContext;
